(function () {
  'use strict';

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    var roots = document.querySelectorAll('.mizumi-product');
    if (!roots.length) return;

    roots.forEach(function (root) {
      if (root.hasAttribute('data-mizumi-product-init')) return;
      root.setAttribute('data-mizumi-product-init', 'true');

      var state = {
        productData: parseProductJson(root),
        selectedOptions: [],
        mode: root.getAttribute('data-default-mode') || 'subscribe',
        quantity: 1
      };

      initSelectedOptions(root, state);

      initGallery(root);
      initVariantPicker(root, state);
      initSubscriptionToggle(root, state);
      initQuantityStepper(root, state);
      initAddToCart(root, state);
      initFaq(root);
      initStickyBar(root);
      initScrollReveal(root);
    });
  }

  function parseProductJson(root) {
    var node = root.querySelector('[data-mizumi-product-json]');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (err) {
      return null;
    }
  }

  function initSelectedOptions(root, state) {
    if (!state.productData) return;
    var firstAvailable = (state.productData.variants || []).find(function (v) { return v.available; })
      || state.productData.variants[0];
    if (firstAvailable && firstAvailable.options) {
      state.selectedOptions = firstAvailable.options.slice();
    }

    var pills = root.querySelectorAll('[data-mizumi-option]');
    pills.forEach(function (pill) {
      if (pill.classList.contains('active')) {
        var idx = parseInt(pill.getAttribute('data-mizumi-option'), 10);
        state.selectedOptions[idx] = pill.getAttribute('data-mizumi-option-value-text');
      }
    });
  }

  /* === Gallery === */
  function initGallery(root) {
    var mainImg = root.querySelector('[data-mizumi-main-image]');
    var thumbs = root.querySelectorAll('[data-mizumi-thumb]');
    if (!mainImg || !thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');

        var src = thumb.getAttribute('data-image-src');
        var srcset = thumb.getAttribute('data-image-srcset');
        var alt = thumb.getAttribute('data-image-alt');
        if (!src) return;

        mainImg.classList.add('fading');
        setTimeout(function () {
          mainImg.src = src;
          if (srcset) mainImg.setAttribute('srcset', srcset);
          if (alt) mainImg.alt = alt;
          requestAnimationFrame(function () { mainImg.classList.remove('fading'); });
        }, 180);
      });
    });
  }

  /* === Variant picker === */
  function initVariantPicker(root, state) {
    var pills = root.querySelectorAll('[data-mizumi-option]');
    if (!pills.length) return;

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var idx = parseInt(pill.getAttribute('data-mizumi-option'), 10);
        var value = pill.getAttribute('data-mizumi-option-value-text');

        root.querySelectorAll('[data-mizumi-option="' + idx + '"]').forEach(function (p) {
          p.classList.remove('active');
          p.setAttribute('aria-checked', 'false');
        });
        pill.classList.add('active');
        pill.setAttribute('aria-checked', 'true');

        var header = pill.closest('.mizumi-option-group');
        if (header) {
          var valueEl = header.querySelector('[data-mizumi-option-value]');
          if (valueEl) valueEl.textContent = value;
        }

        state.selectedOptions[idx] = value;
        updateSelectedVariant(root, state);
      });
    });
  }

  function findVariantByOptions(productData, options) {
    if (!productData || !productData.variants) return null;
    return productData.variants.find(function (v) {
      if (!v.options) return false;
      return v.options.every(function (opt, i) { return opt === options[i]; });
    }) || null;
  }

  function updateSelectedVariant(root, state) {
    var variant = findVariantByOptions(state.productData, state.selectedOptions);
    var addButtons = root.querySelectorAll('[data-mizumi-add-to-cart]');
    var formVariant = root.querySelector('[data-mizumi-form-variant]');

    if (!variant) {
      addButtons.forEach(function (btn) {
        btn.setAttribute('disabled', '');
        var textEl = btn.querySelector('.mizumi-add-text');
        if (textEl) textEl.textContent = 'unavailable';
      });
      return;
    }

    addButtons.forEach(function (btn) {
      btn.setAttribute('data-variant-id', variant.id);
      if (variant.available) {
        btn.removeAttribute('disabled');
      } else {
        btn.setAttribute('disabled', '');
      }
    });

    if (formVariant) formVariant.value = variant.id;

    if (variant.price != null) {
      var basePrice = variant.price;
      root.setAttribute('data-base-price', basePrice);
      var discount = parseInt(root.getAttribute('data-sub-discount'), 10) || 15;
      var subPrice = Math.round(basePrice * (100 - discount) / 100);
      root.setAttribute('data-sub-price', subPrice);

      var oneTimeDisplay = formatMoney(basePrice);
      var subDisplay = formatMoney(subPrice);

      var onetimeEl = root.querySelector('[data-mizumi-price="onetime"]');
      var subEl = root.querySelector('[data-mizumi-price="subscribe"]');
      var strikeEl = root.querySelector('[data-mizumi-price-strike]');
      if (onetimeEl) onetimeEl.textContent = oneTimeDisplay;
      if (subEl) subEl.textContent = subDisplay;
      if (strikeEl) strikeEl.textContent = oneTimeDisplay;

      root.querySelectorAll('[data-mizumi-toggle="onetime"]').forEach(function (b) {
        b.setAttribute('data-price-display', oneTimeDisplay);
        var pEl = b.querySelector('.mizumi-toggle-price');
        if (pEl) pEl.textContent = oneTimeDisplay;
      });
      root.querySelectorAll('[data-mizumi-toggle="subscribe"]').forEach(function (b) {
        b.setAttribute('data-price-display', subDisplay);
        var pEl = b.querySelector('.mizumi-toggle-price');
        if (pEl) pEl.textContent = subDisplay;
      });

      syncPriceDisplay(root, state.mode);
    }
  }

  function formatMoney(cents) {
    if (cents == null || isNaN(cents)) return '';
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && window.Shopify.money_format) {
      try { return window.Shopify.formatMoney(cents, window.Shopify.money_format); } catch (e) {}
    }
    var amount = (cents / 100).toFixed(2);
    return '$' + amount;
  }

  /* === Subscription toggle === */
  function initSubscriptionToggle(root, state) {
    var buttons = root.querySelectorAll('[data-mizumi-toggle]');
    if (!buttons.length) return;

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var mode = btn.getAttribute('data-mizumi-toggle');
        if (!mode || mode === state.mode) return;
        state.mode = mode;

        buttons.forEach(function (b) {
          var isActive = b.getAttribute('data-mizumi-toggle') === mode;
          b.classList.toggle('active', isActive);
          b.setAttribute('aria-checked', isActive ? 'true' : 'false');
        });

        syncPriceDisplay(root, mode);
      });
    });

    syncPriceDisplay(root, state.mode);
  }

  function syncPriceDisplay(root, mode) {
    var onetime = root.querySelector('[data-mizumi-price="onetime"]');
    var sub = root.querySelector('[data-mizumi-price="subscribe"]');
    var strike = root.querySelector('[data-mizumi-price-strike]');
    var tag = root.querySelector('[data-mizumi-price-tag]');
    var btnPrice = root.querySelector('[data-mizumi-button-price]');
    var stickyPrice = root.querySelector('[data-mizumi-sticky-price]');

    if (mode === 'subscribe') {
      if (onetime) onetime.hidden = true;
      if (sub) sub.hidden = false;
      if (strike) strike.hidden = false;
      if (tag) tag.hidden = false;
      var subVal = sub ? sub.textContent.trim() : '';
      if (btnPrice && subVal) btnPrice.textContent = subVal;
      if (stickyPrice && subVal) stickyPrice.textContent = subVal;
    } else {
      if (onetime) onetime.hidden = false;
      if (sub) sub.hidden = true;
      if (strike) strike.hidden = true;
      if (tag) tag.hidden = true;
      var oneVal = onetime ? onetime.textContent.trim() : '';
      if (btnPrice && oneVal) btnPrice.textContent = oneVal;
      if (stickyPrice && oneVal) stickyPrice.textContent = oneVal;
    }
  }

  /* === Quantity stepper === */
  function initQuantityStepper(root, state) {
    var input = root.querySelector('[data-mizumi-qty-input]');
    var buttons = root.querySelectorAll('[data-mizumi-qty]');
    if (!input || !buttons.length) return;

    function sync(val) {
      var n = Math.max(1, Math.min(99, parseInt(val, 10) || 1));
      input.value = n;
      state.quantity = n;
      var formQty = root.querySelector('[data-mizumi-form-qty]');
      if (formQty) formQty.value = n;
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var dir = btn.getAttribute('data-mizumi-qty');
        var current = parseInt(input.value, 10) || 1;
        sync(dir === 'plus' ? current + 1 : current - 1);
      });
    });

    input.addEventListener('change', function () { sync(input.value); });
    input.addEventListener('input', function () { sync(input.value); });
    sync(input.value);
  }

  /* === Add to cart === */
  function initAddToCart(root, state) {
    var buttons = root.querySelectorAll('[data-mizumi-add-to-cart]');
    if (!buttons.length) return;

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (btn.disabled) return;

        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId) return;

        var originalText = btn.querySelector('.mizumi-add-text');
        var originalHTML = originalText ? originalText.innerHTML : btn.innerHTML;
        var originalBg = btn.style.background;
        btn.disabled = true;

        if (originalText) originalText.textContent = 'adding...';

        var sellingPlan = state.mode === 'subscribe' ? findSellingPlan(state.productData, variantId) : null;

        var formData = {
          id: parseInt(variantId, 10),
          quantity: state.quantity || 1
        };
        if (sellingPlan) formData.selling_plan = sellingPlan;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(formData)
        })
          .then(function (r) {
            if (!r.ok) throw new Error('cart add failed');
            return r.json();
          })
          .then(function () {
            if (originalText) originalText.textContent = '✓ added to ritual 💖';
            btn.style.background = '#22c55e';
            return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
          })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.querySelectorAll('[data-cart-count]').forEach(function (el) {
              el.textContent = cart.item_count;
            });
            document.dispatchEvent(new CustomEvent('mizumi:cart-updated', { detail: cart }));
          })
          .catch(function () {
            if (originalText) originalText.textContent = 'try again';
            btn.style.background = '#ef4444';
          })
          .then(function () {
            setTimeout(function () {
              if (originalText) originalText.innerHTML = originalHTML;
              btn.style.background = originalBg;
              btn.disabled = false;
            }, 2200);
          });
      });
    });
  }

  function findSellingPlan(productData, variantId) {
    if (!productData || !productData.variants) return null;
    var variant = productData.variants.find(function (v) { return String(v.id) === String(variantId); });
    if (!variant || !variant.selling_plan_allocations || !variant.selling_plan_allocations.length) return null;
    return variant.selling_plan_allocations[0].selling_plan_id;
  }

  /* === FAQ accordion === */
  function initFaq(root) {
    var items = root.querySelectorAll('.mizumi-faq-item');
    if (!items.length) return;

    items.forEach(function (item) {
      var btn = item.querySelector('.mizumi-faq-q');
      if (!btn) return;
      btn.setAttribute('aria-expanded', 'false');

      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('open');
        items.forEach(function (other) {
          other.classList.remove('open');
          var otherBtn = other.querySelector('.mizumi-faq-q');
          if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          item.classList.add('open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* === Sticky bar visibility === */
  function initStickyBar(root) {
    var bar = root.querySelector('[data-mizumi-sticky-bar]');
    if (!bar) return;

    var primaryAdd = root.querySelector('.mizumi-product-info [data-mizumi-add-to-cart]');
    if (!primaryAdd || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var visible = !entry.isIntersecting;
          bar.classList.toggle('visible', visible);
          bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
        });
      },
      { threshold: 0, rootMargin: '0px 0px -40px 0px' }
    );

    observer.observe(primaryAdd);
  }

  /* === Scroll reveal === */
  function initScrollReveal(root) {
    var targets = root.querySelectorAll('.mizumi-reveal');
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('visible'); });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -50px 0px' }
    );

    targets.forEach(function (el) { observer.observe(el); });
  }
})();
